import React from 'react';
import PropTypes from 'prop-types';

const CircleCounter = props => {
  const { counter } = props
  return (
    <div className="s-w-24px s-h-24px s-cross-center s-main-center s-circle s-bg-blue s-color-white smallest circle-radius s-ml-4px">
      {counter}
    </div>
  );
};

CircleCounter.propTypes = {
  counter: PropTypes.number.isRequired,
};

export default CircleCounter;
